import { Outlet } from 'react-router-dom';
import { SiteShell } from '../site/SiteShell';

export function Layout() {
  return (
    <SiteShell>
      <Outlet />
    </SiteShell>
  );
}
